import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const Header = styled(Flex as any)<IWithSize>`
  box-shadow: 0px 1px 6px 0 rgba(0, 0, 0, 0.35);
  border: solid 1px ${(props: ITheme) => props.theme.colors.palette.whiteTwo};
  flex-direction: column;
  padding: ${({ size }) =>
    size ? `${9 * size}px ${17 * size}px` : '9px 17px'};
`

export default Header
